module.exports = __webpack_public_path__ + "img/avatar0.bd349978.png";